import { SearchCommentary } from '../search/components/search-results/commentary/searchResultComment.types';
import { SearchDecision } from '../decision/decision.types';

type StringOrArray = Array<string> | string;

type mixedArray = Array<StringOrArray>;

export type WatcherQueryParamsCategories = {
  domaine?: mixedArray;
  juridiction?: mixedArray;
  publi?: mixedArray;
  solution?: mixedArray;
};

type WatcherQueryParams = {
  query: string;
  type: WatcherQueryParamsEnum;
  excludeMoyensAnnexes?: boolean;
  originalQueryKey?: string;
  onlyTopResults?: boolean;
  selectedKeywords?: Array<string>;
  restrictToLawArticleIds?: Array<string>;
  cats?: WatcherQueryParamsCategories;
  party?: { name?: string; type?: string };
  otherParty?: { name?: string; type?: string };
  chrono?: boolean;
  excludeMoyens?: boolean;
  chronoInverted?: boolean;
  dateFrom?: string;
  sortNbrCommentaire?: boolean;
};

export type WatcherEnterpriseId = {
  eid: string;
};

export type WatcherLawyerId = {
  lid: string;
};

export type WatcherLawFirmId = {
  oid: string;
};

export type WatcherEntitityId =
  | WatcherEnterpriseId
  | WatcherLawyerId
  | WatcherLawFirmId;

export type WatcherEnterpriseQueryParams = WatcherQueryParams &
  WatcherEnterpriseId;
export type WatcherLawyerQueryParams = WatcherQueryParams &
  WatcherLawyerId & { pictureUrl?: string };
export type WatcherLawFirmQueryParams = WatcherQueryParams & WatcherLawFirmId;

export type WatcherEntityQueryParams =
  | WatcherLawyerQueryParams
  | WatcherLawFirmQueryParams
  | WatcherEnterpriseQueryParams;

export type WatcherSearchQueryParams =
  | WatcherQueryParams
  | WatcherEntityQueryParams;

export enum WatcherQueryParamsEnum {
  DECISION = 'arret',
  COMMENTARY = 'commentary',
}

export enum WatcherSearchQueryEnum {
  DECISION = 'decision',
  COMMENTARY = 'commentary',
}

export enum WatcherCountEnum {
  TOTAL = 'total',
  DECISION = 'decision',
  COMMENTARY = 'commentary',
}

export type WatcherSearchQuery = {
  type: WatcherSearchQueryEnum;
  query: WatcherSearchQueryParams;
};

export type WatcherSearchQueryList = Array<WatcherSearchQuery>;

export type WatcherEnterpriseSearchQuery = {
  type: WatcherSearchQueryEnum.DECISION;
  query: WatcherEnterpriseQueryParams;
};

export type WatcherLawyerSearchQuery = {
  type: WatcherSearchQueryEnum.DECISION;
  query: WatcherLawyerQueryParams;
};

export type WatcherLawFirmSearchQuery = {
  type: WatcherSearchQueryEnum.DECISION;
  query: WatcherLawFirmQueryParams;
};

export type WatcherEntitySearchQuery = {
  type: WatcherSearchQueryEnum.DECISION;
  query: WatcherEntityQueryParams;
};

export type WatcherCount = {
  type: WatcherCountEnum | WatcherSearchQueryEnum;
  total: number;
  read: number;
  notRead: number;
};

export type WatcherWithoutDocuments = {
  key: string;
  searchQueries: WatcherSearchQueryList;
  createdAt?: string;
  counts: { documents: Array<WatcherCount> };
};

type CommonWatcherDocument = {
  isRead: boolean;
  createdAt: string;
  docId: string;
};

export type WatcherCommentary = CommonWatcherDocument & {
  type: WatcherSearchQueryEnum.COMMENTARY;
  document: SearchCommentary;
};

export type WatcherDecision = CommonWatcherDocument & {
  type: WatcherSearchQueryEnum.DECISION;
  document: SearchDecision;
};

export type WatcherDocument = WatcherDecision | WatcherCommentary;

export type WatcherEntityItem = {
  uniqueId: string;
  key: string;
};
